"use client";

import React from "react";
import { MessageCircle, Sparkles, Clock, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const features = [{
  icon: Sparkles,
  label: "Asesoría personalizada gratuita"
}, {
  icon: Clock,
  label: "Respuesta en horario de atención"
}, {
  icon: ShieldCheck,
  label: "Atención cálida y directa"
}];
export default function Whatsapp() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="contáctanos-por-whatsapp" data-nav="light" className="relative bg-background py-14 md:py-20 lg:py-24 text-foreground overflow-hidden">
      {/* Decorative subtle background accents */}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -left-24 size-96 rounded-full bg-accent/40 blur-3xl" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -right-24 size-96 rounded-full bg-secondary/50 blur-3xl" />

      <div className="container mx-auto max-w-4xl px-5 sm:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative rounded-3xl border border-border bg-card p-8 sm:p-12 md:p-16 text-center shadow-sm">
          {/* Botanical Pill Tag */}
          <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-border bg-accent/60 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
            <span className="size-2 rounded-full bg-primary" />
            <span>Atención personalizada</span>
          </div>

          {/* Heading */}
          <h2 className="font-serif text-2xl font-medium tracking-tight text-card-foreground sm:text-3xl md:text-4xl">
            ¿Tienes dudas sobre tu ritual?
          </h2>

          {/* Subtitle */}
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            Escríbenos para recibir orientación personalizada de una asesora de Spora sobre cómo integrar los hongos funcionales en tu día a día.
          </p>

          {/* WhatsApp CTA Action */}
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="h-12 rounded-full bg-primary px-8 text-base font-semibold text-primary-foreground shadow-sm transition-[color,background-color,border-color,box-shadow] duration-200 hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-ring">
              <Link to="https://wa.me/5639561232" newTab aria-label="Abrir conversación en WhatsApp con Spora">
                <MessageCircle className="size-5" />
                <span>Escríbenos por WhatsApp</span>
              </Link>
            </Button>
          </div>

          {/* Mini reassuring badges */}
          <div className="mt-10 pt-8 border-t border-border grid grid-cols-1 gap-4 sm:grid-cols-3">
            {features.map((item, index) => {
            const Icon = item.icon;
            return <div key={index} data-index={index} className="flex items-center justify-center gap-2.5 text-xs font-medium text-muted-foreground sm:text-sm">
                  <div className="flex size-7 items-center justify-center rounded-full bg-secondary text-primary">
                    <Icon className="size-3.5" />
                  </div>
                  <span>{item.label}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}